
<v-app id="app">
  <ToolBar/>
  <v-main id="appContent">
    <v-container fluid>
      <router-view :key="$route.fullPath"/>
    </v-container>
  </v-main>
  <Footer/>
</v-app>
